import React from 'react';
import '../../../css/components/timeline.css';
import { Link } from 'react-router-dom';

const NewsEvent = ({ artikel = [] }) => {
    const baseUrl = "https://admin.sman2amlapura.sch.id/images/artikel/";
    const dataArtikel = artikel?.data || []
    return (
        <section id="news" className="py-16 w-full bg-blue-100 border-gray-200 border-y-8">
            <div className="container mx-auto">
                <div className="row">
                    <div className="mb-10 text-center">
                        <h2 className="text-5xl font-bold text-gray-800 uppercase">News Event</h2>
                        <h3 className="mt-2 text-xl text-gray-500">Latest News from Osis Smandapura</h3>
                    </div>
                </div>

                <div className="row">
                    <div className="px-3 col-lg-12">
                        <ul className="timeline">
                            {dataArtikel.slice(0, 4).map((row, index) => {
                                const timelineClass = index % 2 === 0 ? '' : 'timeline-inverted';
                                return (
                                    <li key={row.encrypted_id} className={timelineClass}>
                                        <div className="timeline-image">
                                            <img
                                                className="object-cover w-full h-full rounded-full"
                                                src={row.gambar_artikel
                                                    ? `https://admin.sman2amlapura.sch.id/images/artikel/${row.gambar_artikel}`
                                                    : "/images/default.png"
                                                }
                                                alt=""
                                            />
                                        </div>
                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4 className="text-lg font-bold text-gray-800">
                                                    <Link to={`/article/${row.encrypted_id}`} className="hover:underline">
                                                        {row.judul_artikel}
                                                    </Link>
                                                </h4>
                                            </div>
                                            <div className="timeline-body">
                                                <p className="text-muted line-clamp-3">{row.konten_artikel}</p>
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}

                            <li className="timeline-inverted">
                                <Link to="/article">
                                    <div className="timeline-image">
                                        <h4 className='font-bold font-montserrat'>
                                            See
                                            <br />
                                            Our
                                            <br />
                                            Artikel!
                                        </h4>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default NewsEvent;
